import type { MeResponse, PublicUser } from '@repo/types';

// All calls use credentials:'include' so the httpOnly session cookie rides along.
// (It's same-origin in prod and via the Vite proxy in dev, but include is explicit.)

/** Read the current session user, or null when browsing as a guest. */
export async function getMe(): Promise<PublicUser | null> {
  const res = await fetch('/api/auth/me', { credentials: 'include' });
  if (!res.ok) throw new Error(`/api/auth/me responded ${res.status}`);
  const body: MeResponse = await res.json();
  return body.user;
}

/** Exchange a Google ID token for a session; resolves to the signed-in user. */
export async function signInWithGoogle(credential: string): Promise<PublicUser> {
  const res = await fetch('/api/auth/google', {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ credential }),
  });
  if (!res.ok) throw new Error(`Sign-in failed (${res.status})`);
  return res.json();
}

/** End the session (drops the server row and clears the cookie). */
export async function signOut(): Promise<void> {
  await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
}
